import { alpha, Stack, Typography, useTheme } from "@mui/material";
import Grid2 from "@mui/material/Grid";

export const LandingVector = ({ items }) => {
  const theme = useTheme();
  return (
    <>
      <Grid2 container spacing={2}>
        {items.map((item, index) => {
          return (
            <Grid2 key={index} item xs={12} sm={6} md={3}>
              <Stack
                direction={"column"}
                justifyContent={"space-between"}
                sx={{
                  p: 3,
                  backgroundColor: alpha(theme.palette.primary.main, 0.16),
                  borderRadius: 1.5,
                  height: "100%",
                }}
              >
                <Typography variant="h3">{index + 1}</Typography>
                <Typography sx={{ alignSelf: "bottom" }} variant="subtitle2">
                  {item}
                </Typography>
              </Stack>
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};
